import phoneInput from './phone/phone';
import phoneLogin from './phone/login';
import phoneReg from './phone/reg';
export default {
  name: 'phonewrap',
  props: {
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      phone: '',
      itc: '',
      country: '',
      regType: 'input'
    };
  },
  components: {
    'phone-input': phoneInput,
    'phone-login': phoneLogin,
    'phone-reg': phoneReg
  },
  computed: {
    componentState: function componentState() {
      return this.wayType === 'phone' && this.regType === '' ? 'input' : this.regType;
    }
  },
  methods: {
    showForgetHandle: function showForgetHandle(type, name, itc, country) {
      this.$emit('showForget', type, name, itc, country);
    },
    successHandle: function successHandle(data) {
      this.$emit('success', data);
    },
    inputPhoneHandle: function inputPhoneHandle(type, name, itc, country) {
      this.regType = type;
      this.phone = name;
      this.itc = itc;
      this.country = country;
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};